export type FormState = {
  values: {
    [key: string]: string | boolean
    topic: string
    name: string
    company: string
    email: string
    phone: string
    message: string
    consent: boolean
  }
  validities: {
    [key: string]: boolean
  }
  submitTouched: boolean
  formIsValid: boolean
}

export enum ActionTypes {
  FORM_UPDATE = 'FORM_UPDATE',
  FORM_SUBMIT = 'FORM_SUBMIT',
}

type FormUpdateType = {
  type: typeof ActionTypes.FORM_UPDATE
  fieldId: string
  value: string
  isValid: boolean
}

type FormSubmitType = {
  type: typeof ActionTypes.FORM_SUBMIT
}

export type FormActionTypes = FormUpdateType | FormSubmitType
